<template>
  <div
    class="basic_article_classification_index"
    @mouseenter="module_isHover(true)"
    @mouseleave="module_isHover(false)"
    @dblclick="changeStyle('style')"
  >
    <div class="tooptipPart module_edit_btn" v-if="isHover">
      <my_hover_btn :tips="$t('widgets_basic_article_classification_index_336')" btnIcon="el-icon-edit" @changeStyle="changeStyle('style')"></my_hover_btn>
      <my_hover_btn
        :tips="$t('widgets_basic_article_classification_edit_330')"
        btnIcon="el-icon-magic-stick"
        @changeStyle="changeStyle('animation')"
        v-if="$store.state.app.view_pattern === 'pc'"
      ></my_hover_btn>
      <my_hover_btn
        :tips="$t('widgets_basic_article_classification_index_337')"
        btnIcon="el-icon-edit-outline"
        @changeStyle="add_content"
        v-if="$store.state.app.view_pattern === 'pc'"
      ></my_hover_btn>
      <my_close_btn :module="module" :column="column" :moduleIndex="module_index" v-if="$store.state.app.view_pattern === 'pc'"></my_close_btn>
    </div>
    <my_title_index :title="widgets_infor.title"></my_title_index>
    <div class="view_pattern_pc" v-if="$store.state.app.view_pattern === 'pc'">
      <div class="data_empty" v-if="filterList.length <= 0">
        <i class="empty_tips_img"></i>
        <div class="empty_tips_text">{{$t('widgets_basic_article_classification_index_338')}}</div>
        <div class="btn_group">
          <el-button type="primary" size="medium" @click="changeStyle('style')">{{$t('widgets_basic_article_classification_index_339')}}</el-button>
          <el-button size="medium" @click="add_content">{{$t('widgets_basic_article_classification_edit_320')}}</el-button>
        </div>
      </div>
       <div
        v-else
        class="content_detail"
        :class="{content_detail_style0: listArr.moduleStyle === 0, content_detail_style1: listArr.moduleStyle === 1}"
      >
        <div class="article_type_all" v-if="listArr.articleType === 'all'">
          <ul class="level_1">
            <li v-for="level_1_item in filterList" :key="level_1_item.id" :style="borderStyle">
              <div>
                <div class="title">
                  <span
                    @click.stop="templet.is_jump({href:`${routerType}?typeId=${level_1_item.id}`,target:pc_widgets_infor.linkType})"
                    :style="[Number(searchID) === Number(level_1_item.id) ? se_fontStyle : fontStyle, lineHeight,{'--seColor':seColor}]"
                    :class="{ actived: Number(searchID) === Number(level_1_item.id) }"
                    @mouseenter="mouseEnter"
                    @mouseleave="mouseLeave"
                  >{{ level_1_item.name }}</span>
                </div>
              </div>
              <ul class="level_2" :class="{ vertical: is_vertical(level_1_item.children) }" v-if="level_1_item.children">
                <li v-for="level_2_item in level_1_item.children" :key="level_2_item.id">
                  <span
                   @click.stop="templet.is_jump({href:`${routerType}?typeId=${level_2_item.id}`,target:pc_widgets_infor.linkType})"
                    :style="[Number(searchID) === Number(level_2_item.id) ? se_fontStyle : fontStyle, lineHeight,{'--seColor':seColor}]"
                    :class="{ actived: Number(searchID) === Number(level_2_item.id) }"
                    @mouseenter="mouseEnter"
                    @mouseleave="mouseLeave"
                  >{{ level_2_item.name }}</span>
                  <ul class="level_3" :class="{ vertical: is_vertical(level_2_item.children) }" v-if="level_2_item.children">
                    <li v-for="level_3_item in level_2_item.children" :key="level_3_item.id">
                      <span
                        @click.stop="templet.is_jump({href:`${routerType}?typeId=${level_3_item.id}`,target:pc_widgets_infor.linkType})"
                        :style="[Number(searchID) === Number(level_3_item.id) ? se_fontStyle : fontStyle, lineHeight,{'--seColor':seColor}]"
                        :class="{ actived: Number(searchID) === Number(level_3_item.id) }"
                        @mouseenter="mouseEnter"
                        @mouseleave="mouseLeave"
                      >{{ level_3_item.name }}</span>
                      <ul class="level_4" v-if="level_3_item.children">
                        <li v-for="level_4_item in level_3_item.children" :key="level_4_item.id">
                          <span
                            @click.stop="templet.is_jump({href:`${routerType}?typeId=${level_4_item.id}`,target:pc_widgets_infor.linkType})"
                            :style="[Number(searchID) === Number(level_4_item.id) ? se_fontStyle : fontStyle, lineHeight,{'--seColor':seColor}]"
                            :class="{ actived: Number(searchID) === Number(level_4_item.id) }"
                            @mouseenter="mouseEnter"
                            @mouseleave="mouseLeave"
                          >{{ level_4_item.name }}</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="article_type_appoint" v-if="listArr.articleType === 'appoint'">
          <ul class="level_1">
            <li v-for="item in filterList" :key="item.value" :style="borderStyle">
              <div>
                <div class="title">
                  <span
                    @click.stop="templet.is_jump({href:`${routerType}?typeId=${item.data.id}`,target:pc_widgets_infor.linkType})"
                    :style="[Number(searchID) === Number(item.data.id) ? se_fontStyle : fontStyle, lineHeight,{'--seColor':seColor}]"
                    :class="{ actived: Number(searchID) === Number(item.data.id) }"
                    @mouseenter="mouseEnter"
                    @mouseleave="mouseLeave"
                  >{{ item.data.name }}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="view_pattern_mb" v-if="$store.state.app.view_pattern === 'mb'">
      <my_mb_empty_tips v-if="filterList.length <= 0" :tip="$t('widgets_basic_article_classification_edit_317')"></my_mb_empty_tips>
      <div v-else class="content_detail">
        <div class="article_type_all" v-if="listArr.articleType === 'all'">
          <ul class="level_1">
            <li v-for="level_1_item in filterList" :key="level_1_item.id">
              <div>
                <div class="title">
                  <span
                    @click.stop="templet.is_jump({href:`${routerType}?typeId=${level_1_item.id}`,target:pc_widgets_infor.linkType})"
                    :style="[Number(searchID) === Number(level_1_item.id) ? se_fontStyle : fontStyle, lineHeight, borderStyle,{'--seColor':seColor}]"
                    :class="{ actived: Number(searchID) === Number(level_1_item.id) }"
                    @mouseenter="mouseEnter"
                    @mouseleave="mouseLeave"
                  >
                    {{ level_1_item.name }}
                    <i
                      class="iconfont icon-jiantouyou"
                      :class="{open: level_1_item.display}"
                      v-if="level_1_item.children"
                      @click.prevent="show_level($event, level_1_item)"
                    ></i>
                  </span>
                </div>
              </div>
              <ul
                class="level_2"
                :class="{level_2_show: level_1_item.display === true }"
                v-if="level_1_item.children"
              >
                <li
                  v-for="level_2_item in level_1_item.children"
                  :key="level_2_item.id"
                  :style="`background: ${level_2_item.children ? '#fff' : '#fafafa'}`"
                >
                  <span
                    @click.stop="templet.is_jump({href:`${routerType}?typeId=${level_2_item.id}`,target:pc_widgets_infor.linkType})"
                    :style="[Number(searchID) === Number(level_2_item.id) ? se_fontStyle: fontStyle, lineHeight, borderStyle,{'--seColor':seColor}]"
                    :class="{ actived: Number(searchID) === Number(level_2_item.id) }"
                    @mouseenter="mouseEnter"
                    @mouseleave="mouseLeave"
                  >
                    {{ level_2_item.name }}
                    <i
                      class="iconfont icon-jiantouyou"
                      :class="{open: level_2_item.display}"
                      v-if="level_2_item.children"
                      @click.prevent="show_level($event, level_2_item)"
                    ></i>
                  </span>
                  <ul
                    class="level_3"
                    v-if="level_2_item.children"
                  >
                    <li
                      v-for="level_3_item in level_2_item.children"
                      :key="level_3_item.id"
                      :style="`background: ${level_3_item.children ? '#fff' : '#fafafa'}`"
                    >
                      <span
                        @click.stop="templet.is_jump({href:`${routerType}?typeId=${level_3_item.id}`,target:pc_widgets_infor.linkType})"
                        :style="[Number(searchID) === Number(level_3_item.id) ? se_fontStyle: fontStyle, lineHeight, borderStyle,{'--seColor':seColor}]"
                        :class="{ actived: Number(searchID) === Number(level_3_item.id) }"
                        @mouseenter="mouseEnter"
                        @mouseleave="mouseLeave"
                      >
                        {{ level_3_item.name }}
                        <i
                          class="iconfont icon-jiantouyou"
                          :class="{open: level_3_item.display}"
                          v-if="level_3_item.children"
                          @click.prevent="show_level($event, level_3_item)"
                        ></i>
                      </span>
                      <ul
                        class="level_4"
                        v-if="level_3_item.children"
                        :style="`background: ${level_3_item.children ? '#fff' : '#fafafa'}`"
                      >
                        <li v-for="level_4_item in level_3_item.children" :key="level_4_item.id">
                          <span
                            @click.stop="templet.is_jump({href:`${routerType}?typeId=${level_4_item.id}`,target:pc_widgets_infor.linkType})"
                            :style="[Number(searchID) === Number(level_4_item.id) ? se_fontStyle: fontStyle, lineHeight, borderStyle,{'--seColor':seColor}]"
                            :class="{ actived: Number(searchID) === Number(level_4_item.id) }"
                            @mouseenter="mouseEnter"
                            @mouseleave="mouseLeave"
                          >{{ level_4_item.name }}</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="article_type_appoint" v-if="listArr.articleType === 'appoint'">
          <ul class="level_1">
            <li v-for="item in filterList" :key="item.id">
              <div>
                <div class="title">
                  <span
                    @click.stop="templet.is_jump({href:`${routerType}?typeId=${item.data.id}`,target:pc_widgets_infor.linkType})"
                    :style="[Number(searchID) === Number(item.data.id) ? se_fontStyle: fontStyle, lineHeight, borderStyle,{'--seColor':seColor}]"
                    :class="{ actived: Number(searchID) === Number(item.data.id) }"
                    @mouseenter="mouseEnter"
                    @mouseleave="mouseLeave"
                  >{{ item.data.name }}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <basic_management
      v-if="popShow"
      :showTag.sync="popShow"
      :typeTag="articleType"
      @changeType="getArticleTypeList"
    ></basic_management>
  </div>
</template>

<script>
import i18n from '../../language/index'

import { gettypeList } from '@/api/app.js'
import { treeJsonToArray } from '@/utils/utils.js'
export default {
  name: 'basic_article_classification_index',
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    widgets_infor () {
      return this.module.data[this.$store.state.app.view_pattern + '_widgets_infor']
    },
    pc_widgets_infor () {
      return this.module.data.pc_widgets_infor
    },
    listArr () {
      return this.module.data.listArr
    },
    articleType () {
      let type = 1
      switch (this.module.data.listArr.articleCategory) {
        case 'newsList':
          type = 1
          break
        case 'caseList':
          type = 3
          break
        case 'helpList':
          type = 2
          break
      }
      return type
    },
    routerType () {
      let routerType = 'article_index'
      switch (this.module.data.listArr.articleCategory) {
        case 'newsList':
          routerType = 'article_index'
          break
        case 'caseList':
          routerType = 'case_index'
          break
        case 'helpList':
          routerType = 'help_index'
          break
      }
      return `#/${routerType}`
    },
    fontStyle () {
      let widgets_infor = this.module.data[this.$store.state.app.view_pattern + '_widgets_infor']
      let font = widgets_infor.font[widgets_infor.font.radio_val]
      let fontStyle = {
        fontFamily: font.fontFamily,
        fontSize: font.fontSize + 'px',
        fontWeight: font.fontWeight,
        fontStyle: font.fontStyle,
        textDecoration: font.textDecoration,
        webkitBackgroundClip: 'text',
        color: font.pattern === 'pure_color' ? font.color : 'transparent',
        backgroundImage: font.pattern === 'pure_color' ? '' : `linear-gradient(${font.linear_gradient.deg}deg, ${font.linear_gradient.start_color} ${font.linear_gradient.start_pointer}%, ${font.linear_gradient.end_color} ${font.linear_gradient.end_pointer}%)`
      }
      return fontStyle
    },
    seColor() {
      let widgets_infor = this.module.data[this.$store.state.app.view_pattern + '_widgets_infor']
      let font = widgets_infor.font[widgets_infor.font.radio_val]
      let color = ''
      if(widgets_infor.font.radio_val == 'default') {
        color = this.$store.state.myRender.common.theme_color
      } else {
        color = font.sePattern === 'pure_color' ? font.selectColor : 'transparent'
      }
      return color
    },
    se_fontStyle () {
      let widgets_infor = this.module.data[this.$store.state.app.view_pattern + '_widgets_infor']
      let font = widgets_infor.font[widgets_infor.font.radio_val]
      let color = ''
      let backgroundImage = ''
      if(widgets_infor.font.radio_val == 'default') {
        color = this.$store.state.myRender.common.theme_color
      } else {
        color = font.sePattern === 'pure_color' ? font.selectColor : 'transparent'
      }
      if(widgets_infor.font.radio_val == 'custom') {
        backgroundImage = font.sePattern === 'pure_color' ? '' : `linear-gradient(${font.seLinear_gradient.deg}deg, ${font.seLinear_gradient.start_color} ${font.seLinear_gradient.start_pointer}%, ${font.seLinear_gradient.end_color} ${font.seLinear_gradient.end_pointer}%)`
      }
      let fontStyle = {
        fontFamily: font.fontFamily,
        fontSize: font.fontSize + 'px',
        fontWeight: font.fontWeight,
        fontStyle: font.fontStyle,
        textDecoration: font.textDecoration,
        webkitBackgroundClip: 'text',
        color: color,
        backgroundImage: backgroundImage
      }
      return fontStyle
    },
    lineHeight () {
      let widgets_infor = this.module.data[this.$store.state.app.view_pattern + '_widgets_infor']
      let lineHeight = {
        lineHeight: widgets_infor.lineHeight[widgets_infor.lineHeight.radio_val].lineHeight + 'px'
      }
      return lineHeight
    },
    borderStyle () {
      let widgets_infor = this.module.data[this.$store.state.app.view_pattern + '_widgets_infor']
      let borderStyle = {
        borderBottomWidth: widgets_infor.splitLine[widgets_infor.splitLine.radio_val].borderWidth + 'px',
        borderBottomStyle: widgets_infor.splitLine[widgets_infor.splitLine.radio_val].borderStyle,
        borderBottomColor: widgets_infor.splitLine[widgets_infor.splitLine.radio_val].borderColor
      }
      return borderStyle
    },
    filterList () {
      if (this.module.data.listArr.articleType === 'all') {
        return this.articleTypeList
      }
      if (this.module.data.listArr.articleType === 'appoint') {
        return this.filterBy
      }
      return []
    }
  },
  watch: {
    'listArr.articleTypeList': {
      handler (val) {
        if (val) {
          this.articleTypeList = val
          this.modify_filterByOptions()
        }
      },
      deep: true
    },
    'listArr.filterBy': {
      handler (val) {
        if (val) {
          this.filterBy = val
        }
      },
      deep: true
    }
  },
  data () {
    return {
      isHover: false,
      popShow: false,
      searchID: '',
      articleTypeList: [{}],
      filterBy: [],
      filterByOptions: []
    }
  },
  mounted () {
    if (this.$route.name === 'article_index') {
      this.listArr.articleCategory = 'newsList'
    }
    if (this.$route.name === 'help_index') {
      this.listArr.articleCategory = 'helpList'
    }
    if (this.$route.name === 'case_index') {
      this.listArr.articleCategory = 'caseList'
    }
    this.getArticleTypeList()
    if (this.$route.name === 'article_index' || this.$route.name === 'help_index' || this.$route.name === 'case_index') {
      this.searchID = this.$route.query.typeId
    }
  },
  methods: {
    module_isHover (val) {
      this.isHover = val
    },
    mouseEnter (e) {
      let widgets_infor = this.module.data[this.$store.state.app.view_pattern + '_widgets_infor']
      let font = widgets_infor.font[widgets_infor.font.radio_val]
      e.target.style.cssText = `
        '--seColor':${this.seColor}
        line-height: ${this.lineHeight.lineHeight};
        font-family: ${font.fontFamily};
        font-size: ${font.fontSize}px;
        font-weight: ${font.fontWeight};
        font-style: ${font.fontStyle};
        text-decoration: ${font.textDecoration};
        -webkit-background-clip: text;
        color: ${widgets_infor.font.radio_val === 'custom' ? (font.sePattern === 'pure_color' ? font.selectColor : 'transparent') : ''} !important;
        background-image: ${font.sePattern === 'pure_color' ? '' : `linear-gradient(${font.seLinear_gradient.deg}deg, ${font.seLinear_gradient.start_color} ${font.seLinear_gradient.start_pointer}%, ${font.seLinear_gradient.end_color} ${font.seLinear_gradient.end_pointer}%)`};
      `
    },
    mouseLeave (e) {
      let widgets_infor = this.module.data[this.$store.state.app.view_pattern + '_widgets_infor']
      let font = widgets_infor.font[widgets_infor.font.radio_val]
      e.target.style.cssText = `
        '--seColor':${this.seColor}
        line-height: ${this.lineHeight.lineHeight};
        font-family: ${font.fontFamily};
        font-size: ${font.fontSize}px;
        font-weight: ${font.fontWeight};
        font-style: ${font.fontStyle};
        text-decoration: ${font.textDecoration};
        -webkit-background-clip: text;
        color: ${widgets_infor.font.radio_val === 'custom' ? (font.pattern === 'pure_color' ? font.color : 'transparent') : ''};
        background-image: ${font.pattern === 'pure_color' ? '' : `linear-gradient(${font.linear_gradient.deg}deg, ${font.linear_gradient.start_color} ${font.linear_gradient.start_pointer}%, ${font.linear_gradient.end_color} ${font.linear_gradient.end_pointer}%)`};
      `
    },
    changeStyle (tabName) {
      this.templet.changeStyle(this.module, tabName)
    },
    add_content () {
      this.popShow = true
    },
    getArticleTypeList () {
      gettypeList({ type: this.articleType, hide: 'false',nav_hide: 1 }).then(res => {
        if (res.code === 200) {
          this.articleTypeList = res.data.list
          this.modify_filterByOptions()
        } else {
          this.$message.error(res.message);
        }
      }).catch(error => {
        this.$message.error(error)
      })
    },
    modify_filterByOptions () {
      let articleTypeArr = treeJsonToArray(this.articleTypeList)
      articleTypeArr = articleTypeArr.map((item) => {
        return {
          label: item.name,
          value: item.id,
          data: item
        }
      })
      this.filterByOptions = articleTypeArr
      // 指定内容绑定
      this.filterBy = []
      for (let i = 0; i < this.listArr.filterByIds.length; i++) {
        for (let j = 0; j < this.filterByOptions.length; j++) {
          if (this.listArr.filterByIds[i] === this.filterByOptions[j].value) {
            this.filterBy.push(this.filterByOptions[j])
            break
          }
        }
      }
    },
    is_vertical (item) {
      let is_vertical = false
      for (let i = 0; i < item.length; i++) {
        if (item[i].children) {
          is_vertical = true
          break
        }
      }
      return is_vertical
    },
    show_level (event, level_item) {
      let $dom = $(event.target).parents('li').children('ul').eq(0)
      $dom.css({ height: 'auto', display: 'block' })
      let maxHeight = $dom.height()
      if (level_item.display) {
        level_item.display = false
        $dom.stop().animate({ height: 0 }, 300, function () {
          $dom.css({ display: 'none', height: 'auto' })
        })
      } else {
        level_item.display = true
        $dom.css({ height: 0 })
        $dom.stop().animate({ height: maxHeight + 'px'}, 300, function () {
          $dom.css({ height: 'auto' })
        })
      }
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss" scope>
.basic_article_classification_index {
  a {
    -webkit-background-clip: text;
  }
  .data_empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 90px 0;
    .empty_tips_img {
      display: block;
      width: 157px;
      height: 123px;
      margin: 0 auto 28px;
      background: url(~@/assets/image/default_icon.png) 0 0;
    }
    .empty_tips_text {
      margin-top: 28px;
      font-size: 16px;
      line-height: 24px;
      color: #333;
      text-align: center;
    }
    .btn_group {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin-top: 20px;
      /deep/ .el-button {
        margin: 10px 15px;
      }
    }
  }
  .view_pattern_pc {
    .content_detail {
      &.content_detail_style0 {
        .title {
          color: #666;
        }
        a {
          line-height: 38px;
          // &:hover {
          //   color: var(--theme_color) !important;
          // }
          // &.actived {
          //   color: var(--theme_color) !important;
          // }
        }
        .level_1 {
          & > li {
            padding: 10px 18px;
            border-bottom: 1px solid #ececec;
            &:last-of-type {
              border: none !important;
            }
            & > div {
              display: inline-block;
              .title {
                display: list-item;
                list-style: disc inside;
                font-size: 14px;
                a {
                  color: #333;
                  font-size: 16px;
                  padding: 0 10px;
                  margin-left: -17px;
                }
              }
            }
          }
        }
        .level_2 {
          display: block;
          margin: 0 -11px;
          padding: 0 20px;
          & > li {
            display: inline-block;
            & > a {
              padding: 0 11px;
            }
          }
          &.vertical > li{
            display: block;
          }
        }
        .level_3 {
          display: block;
          margin: 0 -11px;
          padding: 0 20px;
          & > li {
            display: inline-block;
            & > a {
              padding: 0 11px;
            }
          }
          &.vertical > li{
            display: block;
          }
        }
        .level_4 {
          display: block;
          padding: 0 3px;
          & > li {
            display: inline-block;
            & > a {
              padding: 0 8px;
              font-size: 12px;
              color: #999;
            }
          }
        }
      }
      &.content_detail_style1 {
        .title a {
          font-size: 16px;
          color: #333;
        }
        a {
          line-height: 32px;
          padding: 0 10px;
          // &:hover {
          //   color: var(--theme_color) !important;
          // }
          // &.actived {
          //   color: var(--theme_color) !important;
          // }
        }
        .level_1 {
          display: flex;
          flex-wrap: wrap;
          margin-bottom: -1px;
          & > li {
            width: 25%;
            box-sizing: border-box;
            padding: 30px 12px;
            position: relative;
            border-bottom: 1px solid #ececec !important;
            & > div {
              .title {
                a {
                  font-size: 16px;
                  color: #333;
                  line-height: 32px;
                  padding: 0 10px;
                }
              }
            }
            &::after {
              content: "";
              display: block;
              position: absolute;
              top: 20px;
              right: 0;
              height: calc(100% - 40px);
              border-right: 1px dashed #ececec;
            }
          }
        }
        .level_2 {
          & > li {
            display: inline-block;
            & > a {
              line-height: 32px;
              padding: 0 20px;
              font-size: 14px;
              color: #666;
            }
          }
          &.vertical > li{
            display: block;
          }
        }
        .level_3 {
          & > li {
            display: inline-block;
            & > a {
              line-height: 32px;
              padding: 0 30px;
              font-size: 14px;
              color: #666;
            }
          }
          &.vertical > li{
            display: block;
          }
        }
        .level_4 {
          & > li {
            float: left;
            & > a {
              line-height: 32px;
              padding: 0 40px;
              font-size: 12px;
              color: #999;
            }
          }
          &::after {
            content: "";
            display: block;
            clear: both;
          }
        }
      }
    }
  }
  .view_pattern_mb {
    .data_empty {
      padding: 48px 0;
      .empty_tips_text {
        font-size: 14px;
        margin-top: 0;
      }
    }
    .content_detail {
      a {
        display: block;
        width: 100%;
        color: #333;
        border-bottom: 1px solid #ececec;
        position: relative;
        // &.actived {
        //   color: var(--theme_color) !important;
        // }
        .icon-jiantouyou {
          display: block;
          position: absolute;
          top: 0;
          bottom: 0;
          right: 0;
          color: #333;
          font-size: 14px;
          padding: 0 25px;
          line-height: inherit;
          transition: transform 0.3s;
          &.open {
            transform: rotate(-90deg);
          }
        }
      }
      .level_1 {
        & > li {
          line-height: 50px;
          & > div .title {
            a {
              font-size: 15px;
              padding-left: 18px;
              display: block;
            }
          }
        }
      }
      .level_2 {
        display: none;
        & > li {
          & > a {
            font-size: 14px;
            padding-left: 40px;
            display: block;
            width: 100%;
            color: #333;
            border-bottom: 1px solid #ececec;
            position: relative;
          }
        }
      }
      .level_3 {
        display: none;
        & > li {
          & > a {
            font-size: 14px;
            padding-left: 60px;
            display: block;
            width: 100%;
            color: #333;
            border-bottom: 1px solid #ececec;
            position: relative;
          }
        }
      }
      .level_4 {
        display: none;
        & > li {
          & > a {
            font-size: 13px;
            padding-left: 80px;
            background: #fafafa;
          }
        }
      }
    }
  }
}
.actived {
  color: var(--seColor) !important;
}
</style>


// WEBPACK FOOTER //
// src/widgets/basic_article_classification/index.vue